define(["dojo/i18n", "/local/buildagent/work/bab00163f105c0e5/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"nls/ja-jp/mldoStringResource"
,"nls/ko-kr/mldoStringResource"
,"nls/zh-cn/mldoStringResource"
,"/local/buildagent/work/bab00163f105c0e5/assets/js/nls/mldoStringResource.js?absMid=nls/mldoStringResource"
], function(loader, runner) {
   return runner(loader, "nls/mldoStringResource", __webpack_require__.dj.c(), true);
});